module.exports = __webpack_public_path__ + "img/loading.01fc5f62.svg";